import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { getTrialBannerHeight } from "app/components/React/TrialBanner/StyledTrialBanner";
import { PROJECT_BANNER_HEIGHT } from "app/pages/dashboard/components/NavigationHeader/ProjectDashboardHelper";

export const DashboardButtons = styled.div`
    display: flex;
    min-width: 420px;
    width: 50%;
    align-items: center;
    flex-direction: row-reverse;
    & > div {
        display: flex;
    }
    & > * {
        float: right;
        margin-right: 0px;
    }
    & > *:nth-child(2) {
        margin-left: 12px;
        margin-right: 8px;
    }
    .DropdownItem {
        background: transparent;
    }
    @media (max-width: 1200px) {
        width: 45%;
    }
`;

export const getHeaderBannersHeight = (isTrial: boolean, isProject?: boolean): number => {
    const trialBanner = getTrialBannerHeight(isTrial);
    const projectBanner = isProject ? PROJECT_BANNER_HEIGHT : 0;

    return trialBanner + projectBanner;
};

interface IContainerProps {
    isTrial: boolean;
}

export const DashboardHeaderContainer = styled.div<IContainerProps>`
    width: calc(100% - 328px);
    max-width: 1366px;
    display: inline-flex;
    align-items: center;
    justify-content: space-between;
    position: fixed;
    top: ${({ isTrial }) => `${getHeaderBannersHeight(isTrial)}px`};
    height: 104px;
    padding: 53px 10px 13px 5px;
    box-sizing: border-box;
    z-index: 3;
    background-color: ${colorsPalettes.bluegrey["100"]};
    margin-right: auto;
    border-bottom: 0px;
    margin-left: 6px;
    &.layout-is-scrolled {
        border-bottom: 1px solid ${colorsPalettes.carbon["100"]};
        transition: all ease 200ms;
    }
    transition: all ease 200ms;
`;

export const EllipsisIconContainer = styled.div`
    width: 37px;
    height: 100%;

    .SWReactIcons {
        display: inline-flex;
        width: 24px;
        svg {
            width: 100%;
            height: 100%;
        }
    }
`;

export const IconItem: any = styled(FlexRow)`
    svg {
        position: relative;
        top: 2px;
        /* fit to font-size height & width */
        height: 32px;
        width: 32px;
        margin-right: 8px;
        margin-left: ${(props: any) => (props.first ? "0px" : "8px")};
    }
`;

export const ButtonWrapper = styled.div`
    position: relative;
`;
